/** @jsxImportSource @emotion/react */
import { convertEmailRecipientTextListIntoObject, EmailRecipientsTextList, findInfoIndex, getFormObjectFromEntity, getInfoFormFields } from "../utils";
import { Form, FormOptions } from "../PageBase";
import { Client, ClientInfo } from "./types";

export interface ClientInfoFormObject {
    fruit_type: string;
    report_type: string;
    email_recipients: EmailRecipientsTextList;
}

export const defineClientInfoFormCreate = (onSaveClient: (client: Client) => void) => (formOptions: FormOptions | undefined, client: Client | undefined) => {
    const clientInfoForm = getInfoFormFields(formOptions, client);

    const onSave = (formObject: ClientInfoFormObject, entity: Partial<Client>) => {
        const clientInfoIndex = findInfoIndex(entity, formObject.fruit_type, formObject.report_type);
        const clientInfo = entity.infos?.[clientInfoIndex] ?? {} as ClientInfo;
        const fruit_type = formObject.fruit_type === "*" ? undefined : formObject.fruit_type;
        const report_type = formObject.report_type === "*" ? undefined : formObject.report_type;
        const email_recipients = convertEmailRecipientTextListIntoObject(formObject.email_recipients);

        const newClientInfo: ClientInfo = {
            ...clientInfo,
            client_id: entity.id!,
            fruit_type,
            report_type,
            report_status: "READY",
            email_recipients,
        };

        const newClientInfos: ClientInfo[] = [
            ...(entity.infos || []),
        ];

        if (clientInfoIndex >= 0) {
            newClientInfos[clientInfoIndex] = newClientInfo;
        } else {
            newClientInfos.push(newClientInfo);
        }

        const client = {
            ...entity,
            infos: newClientInfos,
        };

        onSaveClient(client as Client);
    };

    const onDelete = (formObject: ClientInfoFormObject, entity: Partial<Client>) => {
        const clientInfoIndex = findInfoIndex(entity, formObject.fruit_type, formObject.report_type);
        const newClientInfos = [
            ...(entity.infos || []),
        ];

        if (clientInfoIndex > -1) {
            newClientInfos.splice(clientInfoIndex, 1);
        }

        const client = {
            ...entity,
            infos: newClientInfos,
        };

        onSaveClient(client as Client);
    };

    const onFieldValueChange = (field: string, value: any, formObject: Partial<ClientInfoFormObject>, entity: Partial<Client>) => {
        if (field === "fruit_type") {
            return {
                ...getFormObjectFromEntity(entity, value, formObject.report_type),
                [field]: value,
            };
        }

        if (field === "report_type") {
            return {
                ...getFormObjectFromEntity(entity, formObject.fruit_type, value),
                [field]: value,
            };
        }

        return {
            ...formObject,
            [field]: value,
        } as ClientInfoFormObject;
    };

    const clientInfoModal: Form<ClientInfoFormObject, Client> = {
        title: "Client Info",
        fields: clientInfoForm,
        modalButtonLabel: "Add Email(s)",
        onSave,
        onDelete,
        getFormObjectFromEntity,
        onFieldValueChange
    };

    return clientInfoModal;
};
